import {
  RefreshCw,
  Send,
  Clapperboard,
  Terminal,
  Database,
  Gamepad2,
  Wrench,
  Languages,
  MoreHorizontal
} from 'lucide-react';

/** Category id for Telegram / bot-type workflows (used when linking bots to workflows). */
export const WORKFLOW_CATEGORY_BOTS = 'bots';

export const WORKFLOW_CATEGORIES = [
  { id: 'automation', label: 'Automation', Icon: RefreshCw },
  { id: WORKFLOW_CATEGORY_BOTS, label: 'Bots', Icon: Send },
  { id: 'media', label: 'Media', Icon: Clapperboard },
  { id: 'logic', label: 'Logic', Icon: Terminal },
  { id: 'data', label: 'Data', Icon: Database },
  { id: 'entertainment', label: 'Entertainment', Icon: Gamepad2 },
  { id: 'tools', label: 'Tools', Icon: Wrench },
  { id: 'localization', label: 'Localization', Icon: Languages },
  { id: 'other', label: 'Other', Icon: MoreHorizontal }
];

export const workflowCategoryLabel = (id) =>
  WORKFLOW_CATEGORIES.find((c) => c.id === id)?.label ?? id;
